export enum SelectStylesEnum {
  'purple' = 'purple',
  'light-peach' = 'light-peach',
}
